/**
 * Scripts to enhance the details element
 */

//Add extra wrappers to the details content, so we can animate them with the grid-template-rows method
document.querySelectorAll('details').forEach((detail) => {
	//Create wrapping elements
	let outer = document.createElement('div');
	outer.classList.add('outer');

	let inner = document.createElement('div');
	inner.classList.add('inner');

	//Stack
	outer.append(inner);

	//Put the nodes inside
	detail.querySelectorAll('summary ~ *').forEach((el) => {
		inner.append(el);
	});

	//Put everything back into the details
	detail.appendChild(outer);
});

//Fake details block transitions
document.querySelectorAll('.wp-block-read-more-toggle').forEach((toggle) => {
	toggle.querySelector('.open-toggle').addEventListener('click', (e) => {
		e.target.parentElement.classList.add('open');
	});

	toggle.querySelector('.close-toggle').addEventListener('click', (e) => {
		//Scroll up
		let opener = e.target.closest('.wp-block-read-more-toggle').querySelector('.open-toggle');

		//Hide
		e.target.closest('.wp-block-read-more-toggle').classList.remove('open');
	});
});
